<template>
    <v-container grid-list-md>
            <div id="printMe" class="marca">
                <!-- <h3 class="visualizado">RECIBO</h3> -->
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left">CPC: {{ data.unionize.cpc }} Nombre: {{ data.unionize.user.name }}</th>
                            <th align="right">Factura Numero: {{ data.id }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left">Rif y/o Cedula: {{ data.unionize.user.nacionality }}{{ data.unionize.user.number_id }}</th>
                            <th align="right">Fecha de Emisión: {{ data.payment_date }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cond. de pago: </th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cajero: {{ data.cash_assignment != null ? data.cash_assignment.cash.name : 'Caja Web' }}</th>
                        </tr>
                    </thead>
                </table>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CODIGO</th>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">DESCRIPCION</th>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CANTIDAD</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">COSTO UNIT.</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">TOTAL Bs.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(concepts, index) in datos" :key="index">
                            <td align="left">{{ concepts.code }}</td>
                            <td align="left">{{ concepts.name }}</td>
                            <td align="left">{{ concepts.cantidad }}  --- {{ concepts.first_last }}</td>
                            <td align="right">--</td>
                            <!-- <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(parseFloat(concepts.monto_serv_pay) / parseInt(concepts.cantidad)).toFixedDown(3)) }}</td> -->
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(concepts.monto_serv_pay) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3" style="border-top: 3px dashed;">FORMA DE PAGO: </td>
                            <td align="right" style="border-top: 3px dashed;">SUB-TOTAL :</td>
                            <td align="right" style="border-top: 3px dashed;">{{ new Intl.NumberFormat("de-DE").format(sup_total) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3"></td>
                            <!-- <td align="right">--.-- % IVA :</td> -->
                            <td align="right">{{ txAmount }} % IVA :</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(monto_iva) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3">SOLO PARA EL USO DEL CONTADOR PUBLICO</td>
                            <td align="right">TOTAL :</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(total) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Pueden existir saltos en las fechas de cuotas pagadas en la factura</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
    </v-container>
</template>

<script>
import axios from 'axios'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    props: {
        data: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            datos: [],
            txAmount: 0,
            total: 0,
            ruap_amount: 0,
            sup_total: 0,
            monto_iva: 0,
            monto_gg: 0,
        }
    },

    mounted() {
        this.getInfoFactura(this.data.id)
    },

    methods: {

        async getInfoFactura(id_invoice) {
            console.log(id_invoice)
            this.$emit('responseLoading', true)
            await axios.get(`/api/administration/cobranza/cuentas-por-cobrar-factura/${id_invoice}`)
                .then(res => {
                    console.log(res.data)
                    this.datos = res.data
                    this.total = parseFloat(res.data[0].monto_factura)
                    this.txAmount = parseFloat(res.data[0].tax)
                    if(this.txAmount != 0) {
                        let suma_iva = 0
                        this.datos.forEach(i => {
                            let iva = parseFloat(i.tax)
                            if(iva != 0){
                                let result_iva = iva / 100
                                suma_iva += parseFloat(i.monto_serv_pay * result_iva)
                            }
                        });
                        this.monto_iva = suma_iva
                        this.sup_total = parseFloat(this.total) - suma_iva
                    }else {
                        this.sup_total = this.total
                    }
                })
                .catch(e => {
                    console.log(e.response)
                })
                .finally(() => this.$emit('responseLoading', false));
        }

    }

}
</script>
<style scoped>

@media print {
    @page {
        /*size: 215.9mm 139.7mm;/* afecta el tamano de la hoja */ 
        margin-top: 35mm; /* afecta el margen de la hoja */ 
    }

    .visualizado {
        display:block;
        margin-bottom: 30px;
    }
}

@media screen {
    
    .visualizado {
        display:none;
    }

    .marca:after {
        content: url('/img/newlogo.png');
        font-size: 15em;
        opacity: 0.1;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 120px;
        right: 0;
        bottom: 0;
        left: 0;

        -webkit-pointer-events: none;
        -moz-pointer-events: none;
        -ms-pointer-events: none;
        -o-pointer-events: none;
        pointer-events: none;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
}



</style>


// WEBPACK FOOTER //
// resources/assets/js/components/factura/FacturaPagoCuentaCobrar.vue